<template>
    <v-container fill-height>
        <v-row justify="center" align="center">
            <v-col cols="12" sm="12">
                <span  class="loginText">
                    {{ $t("signUp.getStarted") }}
                </span>
                <span
                    
                    class="welcomeText"
                    style="margin-top: 11px"
                >
                    {{ $t("signUp.createToContinue") }}
                </span>
                <br />
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-window v-model="step" disabled>
                        <v-window-item :value="1">
                            <v-row style="flex-wrap: nowrap" class="mb-0">
                                <v-col
                                    class="flex-grow-1 flex-shrink-0 justify-start title"
                                >
                                    <span>
                                        {{ $t("signUp.personalInformation") }}
                                    </span>
                                </v-col>
                                
                            </v-row>
                            <v-text-field
                                v-model="name"
                                maxlength="30"
                                id="name"
                                name="name"
                                :placeholder="
                                    $t('placeholder.enter', {
                                        itm: $t('signUp.fullName'),
                                    })
                                "
                                variant="outlined"
                                single-line
                                full-width
                                hide-details
                                required
                            >
                                <template #prepend-inner>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                                            fill="#C5CDD4"
                                        />
                                        <path
                                            d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z"
                                            fill="#C5CDD4"
                                        />
                                    </svg>
                                </template>
                            </v-text-field>
                            <span class="warningHint" id="nameErrorMsg">
                                {{ msg.name }}</span
                            >
                            <v-text-field
                                v-model="email"
                                maxlength="40"
                                id="email"
                                name="email"
                                :placeholder="
                                    $t('placeholder.enter', {
                                        itm: $t('signUp.email'),
                                    })
                                "
                                variant="outlined"
                                single-line
                                full-width
                                hide-details
                                required
                            >
                                <template #prepend-inner>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17 3H7C4 3 2 4.5 2 8V15C2 18.5 4 20 7 20H10.57C11.16 20 11.64 19.48 11.56 18.89C11.46 18.18 11.48 17.44 11.63 16.68C12.16 14.08 14.3 12.01 16.92 11.58C18.23 11.37 19.48 11.55 20.58 12.03C21.25 12.32 22 11.86 22 11.13V8C22 4.5 20 3 17 3ZM17.47 8.59L14.34 11.09C13.68 11.62 12.84 11.88 12 11.88C11.16 11.88 10.31 11.62 9.66 11.09L6.53 8.59C6.21 8.33 6.16 7.86 6.41 7.53C6.67 7.21 7.14 7.15 7.46 7.41L10.59 9.91C11.35 10.52 12.64 10.52 13.4 9.91L16.53 7.41C16.85 7.15 17.33 7.2 17.58 7.53C17.84 7.86 17.79 8.33 17.47 8.59Z"
                                            fill="#C5CDD4"
                                        />
                                        <path
                                            d="M18 13C15.24 13 13 15.23 13 18C13 20.76 15.24 23 18 23C20.77 23 23 20.76 23 18C23 15.23 20.77 13 18 13ZM20.05 17.55L19.68 17.91L17.5 20.1C17.4 20.19 17.21 20.29 17.07 20.31L16.09 20.45C15.74 20.5 15.49 20.25 15.54 19.9L15.68 18.92C15.7 18.78 15.79 18.59 15.89 18.49L18.07 16.32L18.43 15.95C18.67 15.71 18.94 15.55 19.22 15.55C19.46 15.55 19.73 15.66 20.03 15.95C20.7 16.6 20.49 17.11 20.05 17.55Z"
                                            fill="#C5CDD4"
                                        />
                                    </svg>
                                </template>
                            </v-text-field>
                            <span class="warningHint" id="emailErrorMsg">
                                {{ msg.email }}</span
                            >
                            <v-text-field
                                v-model="phoneNumber"
                                id="phoneNumber"
                                name="phoneNumber"
                                maxlength="15"
                                :placeholder="
                                    $t('placeholder.enter', {
                                        itm: $t('signUp.phoneNumber'),
                                    })
                                "
                                variant="outlined"
                                single-line
                                full-width
                                hide-details
                                required
                            >
                                <template #prepend-inner>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M16.24 2H7.76C5 2 4 3 4 5.81V18.19C4 21 5 22 7.76 22H16.23C19 22 20 21 20 18.19V5.81C20 3 19 2 16.24 2ZM12 19.3C11.04 19.3 10.25 18.51 10.25 17.55C10.25 16.59 11.04 15.8 12 15.8C12.96 15.8 13.75 16.59 13.75 17.55C13.75 18.51 12.96 19.3 12 19.3ZM14 6.25H10C9.59 6.25 9.25 5.91 9.25 5.5C9.25 5.09 9.59 4.75 10 4.75H14C14.41 4.75 14.75 5.09 14.75 5.5C14.75 5.91 14.41 6.25 14 6.25Z"
                                            fill="#C5CDD4"
                                        />
                                    </svg>
                                </template>
                            </v-text-field>
                            <span
                                class="warningHint"
                                id="phoneNumberErrorMsg"
                                >{{ msg.phoneNumber }}</span
                            >
                            <v-text-field
                                v-model="password"
                                id="password"
                                name="password"
                                :placeholder="
                                    $t('placeholder.enter', {
                                        itm: $t('signUp.password'),
                                    })
                                "
                                :type="showPass ? 'text' : 'password'"
                                variant="outlined"
                                single-line
                                full-width
                                hide-details
                                class="custom-placeholder"
                            >
                                <template #prepend-inner>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12.0011 17.3498C12.9013 17.3498 13.6311 16.6201 13.6311 15.7198C13.6311 14.8196 12.9013 14.0898 12.0011 14.0898C11.1009 14.0898 10.3711 14.8196 10.3711 15.7198C10.3711 16.6201 11.1009 17.3498 12.0011 17.3498Z"
                                            fill="#C5CDD4"
                                        />
                                        <path
                                            d="M18.28 9.53V8.28C18.28 5.58 17.63 2 12 2C6.37 2 5.72 5.58 5.72 8.28V9.53C2.92 9.88 2 11.3 2 14.79V16.65C2 20.75 3.25 22 7.35 22H16.65C20.75 22 22 20.75 22 16.65V14.79C22 11.3 21.08 9.88 18.28 9.53ZM12 18.74C10.33 18.74 8.98 17.38 8.98 15.72C8.98 14.05 10.34 12.7 12 12.7C13.66 12.7 15.02 14.06 15.02 15.72C15.02 17.39 13.67 18.74 12 18.74ZM7.35 9.44C7.27 9.44 7.2 9.44 7.12 9.44V8.28C7.12 5.35 7.95 3.4 12 3.4C16.05 3.4 16.88 5.35 16.88 8.28V9.45C16.8 9.45 16.73 9.45 16.65 9.45H7.35V9.44Z"
                                            fill="#C5CDD4"
                                        />
                                    </svg>
                                </template>
                                <template #append-inner>
                                    <v-btn
                                        icon
                                        variant="plain"
                                        id="showPass"
                                        name="showPass"
                                        @click="showPass = !showPass"
                                    >
                                        <svg
                                            v-if="showPass"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M21.25 9.14969C18.94 5.51969 15.56 3.42969 12 3.42969C10.22 3.42969 8.49 3.94969 6.91 4.91969C5.33 5.89969 3.91 7.32969 2.75 9.14969C1.75 10.7197 1.75 13.2697 2.75 14.8397C5.06 18.4797 8.44 20.5597 12 20.5597C13.78 20.5597 15.51 20.0397 17.09 19.0697C18.67 18.0897 20.09 16.6597 21.25 14.8397C22.25 13.2797 22.25 10.7197 21.25 9.14969ZM12 16.0397C9.76 16.0397 7.96 14.2297 7.96 11.9997C7.96 9.76969 9.76 7.95969 12 7.95969C14.24 7.95969 16.04 9.76969 16.04 11.9997C16.04 14.2297 14.24 16.0397 12 16.0397Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M11.9984 9.14062C10.4284 9.14062 9.14844 10.4206 9.14844 12.0006C9.14844 13.5706 10.4284 14.8506 11.9984 14.8506C13.5684 14.8506 14.8584 13.5706 14.8584 12.0006C14.8584 10.4306 13.5684 9.14062 11.9984 9.14062Z"
                                                fill="#C5CDD4"
                                            />
                                        </svg>
                                        <svg
                                            v-if="!showPass"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M21.2714 9.17834C20.9814 8.71834 20.6714 8.28834 20.3514 7.88834C19.9814 7.41834 19.2814 7.37834 18.8614 7.79834L15.8614 10.7983C16.0814 11.4583 16.1214 12.2183 15.9214 13.0083C15.5714 14.4183 14.4314 15.5583 13.0214 15.9083C12.2314 16.1083 11.4714 16.0683 10.8114 15.8483C10.8114 15.8483 9.38141 17.2783 8.35141 18.3083C7.85141 18.8083 8.01141 19.6883 8.68141 19.9483C9.75141 20.3583 10.8614 20.5683 12.0014 20.5683C13.7814 20.5683 15.5114 20.0483 17.0914 19.0783C18.7014 18.0783 20.1514 16.6083 21.3214 14.7383C22.2714 13.2283 22.2214 10.6883 21.2714 9.17834Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M14.0206 9.98062L9.98062 14.0206C9.47062 13.5006 9.14062 12.7806 9.14062 12.0006C9.14062 10.4306 10.4206 9.14062 12.0006 9.14062C12.7806 9.14062 13.5006 9.47062 14.0206 9.98062Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M14.8581 11.9981C14.8581 13.5681 13.5781 14.8581 11.9981 14.8581C11.9381 14.8581 11.8881 14.8581 11.8281 14.8381L14.8381 11.8281C14.8581 11.8881 14.8581 11.9381 14.8581 11.9981Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M21.7689 2.22891C21.4689 1.92891 20.9789 1.92891 20.6789 2.22891L2.22891 20.6889C1.92891 20.9889 1.92891 21.4789 2.22891 21.7789C2.37891 21.9189 2.56891 21.9989 2.76891 21.9989C2.96891 21.9989 3.15891 21.9189 3.30891 21.7689L21.7689 3.30891C22.0789 3.00891 22.0789 2.52891 21.7689 2.22891Z"
                                                fill="#C5CDD4"
                                            />
                                        </svg>
                                    </v-btn>
                                </template>
                            </v-text-field>
                            <span class="warningHint" id="passwordErrorMsg">{{
                                msg.password
                            }}</span>
                            <v-text-field
                                v-model="password2"
                                id="password2"
                                name="password2"
                                :placeholder="
                                    $t('placeholder.enter', {
                                        itm: $t('signUp.password'),
                                    })
                                "
                                :type="showPass2 ? 'text' : 'password'"
                                variant="outlined"
                                single-line
                                full-width
                                hide-details
                            >
                                <template v-slot:progress>
                                    <v-progress-linear
                                        :value="progress"
                                        :color="color"
                                        absolute
                                        full-width
                                        height="7"
                                    ></v-progress-linear>
                                </template>
                                <template #prepend-inner>
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12.0011 17.3498C12.9013 17.3498 13.6311 16.6201 13.6311 15.7198C13.6311 14.8196 12.9013 14.0898 12.0011 14.0898C11.1009 14.0898 10.3711 14.8196 10.3711 15.7198C10.3711 16.6201 11.1009 17.3498 12.0011 17.3498Z"
                                            fill="#C5CDD4"
                                        />
                                        <path
                                            d="M18.28 9.53V8.28C18.28 5.58 17.63 2 12 2C6.37 2 5.72 5.58 5.72 8.28V9.53C2.92 9.88 2 11.3 2 14.79V16.65C2 20.75 3.25 22 7.35 22H16.65C20.75 22 22 20.75 22 16.65V14.79C22 11.3 21.08 9.88 18.28 9.53ZM12 18.74C10.33 18.74 8.98 17.38 8.98 15.72C8.98 14.05 10.34 12.7 12 12.7C13.66 12.7 15.02 14.06 15.02 15.72C15.02 17.39 13.67 18.74 12 18.74ZM7.35 9.44C7.27 9.44 7.2 9.44 7.12 9.44V8.28C7.12 5.35 7.95 3.4 12 3.4C16.05 3.4 16.88 5.35 16.88 8.28V9.45C16.8 9.45 16.73 9.45 16.65 9.45H7.35V9.44Z"
                                            fill="#C5CDD4"
                                        />
                                    </svg>
                                </template>
                                <template #append-inner>
                                    <v-btn
                                        icon
                                        variant="plain"
                                        id="showPass2"
                                        name="showPass2"
                                        @click="showPass2 = !showPass2"
                                    >
                                        <svg
                                            v-if="showPass2"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M21.25 9.14969C18.94 5.51969 15.56 3.42969 12 3.42969C10.22 3.42969 8.49 3.94969 6.91 4.91969C5.33 5.89969 3.91 7.32969 2.75 9.14969C1.75 10.7197 1.75 13.2697 2.75 14.8397C5.06 18.4797 8.44 20.5597 12 20.5597C13.78 20.5597 15.51 20.0397 17.09 19.0697C18.67 18.0897 20.09 16.6597 21.25 14.8397C22.25 13.2797 22.25 10.7197 21.25 9.14969ZM12 16.0397C9.76 16.0397 7.96 14.2297 7.96 11.9997C7.96 9.76969 9.76 7.95969 12 7.95969C14.24 7.95969 16.04 9.76969 16.04 11.9997C16.04 14.2297 14.24 16.0397 12 16.0397Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M11.9984 9.14062C10.4284 9.14062 9.14844 10.4206 9.14844 12.0006C9.14844 13.5706 10.4284 14.8506 11.9984 14.8506C13.5684 14.8506 14.8584 13.5706 14.8584 12.0006C14.8584 10.4306 13.5684 9.14062 11.9984 9.14062Z"
                                                fill="#C5CDD4"
                                            />
                                        </svg>
                                        <svg
                                            v-if="!showPass2"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M21.2714 9.17834C20.9814 8.71834 20.6714 8.28834 20.3514 7.88834C19.9814 7.41834 19.2814 7.37834 18.8614 7.79834L15.8614 10.7983C16.0814 11.4583 16.1214 12.2183 15.9214 13.0083C15.5714 14.4183 14.4314 15.5583 13.0214 15.9083C12.2314 16.1083 11.4714 16.0683 10.8114 15.8483C10.8114 15.8483 9.38141 17.2783 8.35141 18.3083C7.85141 18.8083 8.01141 19.6883 8.68141 19.9483C9.75141 20.3583 10.8614 20.5683 12.0014 20.5683C13.7814 20.5683 15.5114 20.0483 17.0914 19.0783C18.7014 18.0783 20.1514 16.6083 21.3214 14.7383C22.2714 13.2283 22.2214 10.6883 21.2714 9.17834Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M14.0206 9.98062L9.98062 14.0206C9.47062 13.5006 9.14062 12.7806 9.14062 12.0006C9.14062 10.4306 10.4206 9.14062 12.0006 9.14062C12.7806 9.14062 13.5006 9.47062 14.0206 9.98062Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M18.25 5.74969L14.86 9.13969C14.13 8.39969 13.12 7.95969 12 7.95969C9.76 7.95969 7.96 9.76969 7.96 11.9997C7.96 13.1197 8.41 14.1297 9.14 14.8597L5.76 18.2497H5.75C4.64 17.3497 3.62 16.1997 2.75 14.8397C1.75 13.2697 1.75 10.7197 2.75 9.14969C3.91 7.32969 5.33 5.89969 6.91 4.91969C8.49 3.95969 10.22 3.42969 12 3.42969C14.23 3.42969 16.39 4.24969 18.25 5.74969Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M14.8581 11.9981C14.8581 13.5681 13.5781 14.8581 11.9981 14.8581C11.9381 14.8581 11.8881 14.8581 11.8281 14.8381L14.8381 11.8281C14.8581 11.8881 14.8581 11.9381 14.8581 11.9981Z"
                                                fill="#C5CDD4"
                                            />
                                            <path
                                                d="M21.7689 2.22891C21.4689 1.92891 20.9789 1.92891 20.6789 2.22891L2.22891 20.6889C1.92891 20.9889 1.92891 21.4789 2.22891 21.7789C2.37891 21.9189 2.56891 21.9989 2.76891 21.9989C2.96891 21.9989 3.15891 21.9189 3.30891 21.7689L21.7689 3.30891C22.0789 3.00891 22.0789 2.52891 21.7689 2.22891Z"
                                                fill="#C5CDD4"
                                            />
                                        </svg>
                                    </v-btn>
                                </template>
                            </v-text-field>
                            <br />
                            <v-row justify="center" align="center">
                                <svg
                                    width="580"
                                    height="4"
                                    viewBox="0 0 580 4"
                                    fill="none"
                                    style="
                                        padding-right: 12px;
                                        padding-left: 12px;
                                    "
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        x="0"
                                        width="100"
                                        height="4"
                                        rx="2"
                                        :fill="
                                            passwordIsNotIdentique
                                                ? '#f95e68'
                                                : score >= 0
                                                ? Color
                                                : '#F3F3F3'
                                        "
                                    />
                                    <rect
                                        x="120"
                                        width="100"
                                        height="4"
                                        rx="2"
                                        :fill="
                                            passwordIsNotIdentique
                                                ? '#f95e68'
                                                : score >= 1
                                                ? Color
                                                : '#F3F3F3'
                                        "
                                    />
                                    <rect
                                        x="240"
                                        width="100"
                                        height="4"
                                        rx="2"
                                        :fill="
                                            passwordIsNotIdentique
                                                ? '#f95e68'
                                                : score >= 2
                                                ? Color
                                                : '#F3F3F3'
                                        "
                                    />
                                    <rect
                                        x="360"
                                        width="100"
                                        height="4"
                                        rx="2"
                                        :fill="
                                            passwordIsNotIdentique
                                                ? '#f95e68'
                                                : score >= 3
                                                ? Color
                                                : '#F3F3F3'
                                        "
                                    />
                                    <rect
                                        x="480"
                                        width="100"
                                        height="4"
                                        rx="2"
                                        :fill="
                                            passwordIsNotIdentique
                                                ? '#f95e68'
                                                : score >= 4
                                                ? Color
                                                : '#F3F3F3'
                                        "
                                    />
                                </svg>
                            </v-row>
                            <password-meter
                                style="visibility: hidden"
                                @score="onScore"
                                :password="password"
                            ></password-meter>
                            <span
                                class="d-flex PasswordHint"
                                v-bind:style="{ color: Color }"
                                v-if="password && !passwordIsNotIdentique"
                            >
                                {{ strengthTranslate }}
                            </span>
                            <span
                                class="d-flex PasswordHint"
                                style="color: #f95e68"
                                v-else-if="passwordIsNotIdentique"
                                >{{ msg.passwordIdentique }}</span
                            >
                            <span class="d-block PasswordHint" v-else
                                >&nbsp;</span
                            >
                            <v-checkbox
                                class="shrink mr-0 mt-0 mb-0 pb-0"
                                v-model="agreeTerm"
                                id="agreeTerm"
                                name="agreeTerm"
                                :label="$t('signUp.agree')"
                                color="#114EF7"
                                hide-details
                            ></v-checkbox>
                            <span class="warningHint" id="agreeTermErrorMsg">{{
                                msg.agreeTerm
                            }}</span>
                        </v-window-item>
                        
                    </v-window> 
                    <v-btn
                        block
                        size="x-large"
                        rounded="lg"
                        dark
                        color="#114EF7"
                        text-color="white"
                        @click="validateFormStep1()"
                        id="signInBTN"
                        name="signInBTN"
                        :disabled="loader"
                    >
                        <span v-if="loader" class="buttonText">
                            <v-progress-circular
                                indeterminate
                                :size="30"
                            ></v-progress-circular>
                        </span>
                        <span class="buttonText">
                            {{ $t("signUp.SignUp").toUpperCase() }}
                        </span>
                    </v-btn>
                    <br />
                </v-form>
                <v-row>
                    <v-col align="justify">
                        <span class="linkText">
                            {{ $t("signUp.haveAccount?") }}
                            <router-link
                                class="linkText"
                                style="color: #114ef7; font-weight: bold"
                                to="/"
                                id="toSignIn"
                                name="toSignIn"
                            >
                                {{ $t("signUp.SignIn") }}
                            </router-link>
                        </span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { defineComponent, ref } from "vue";
import PasswordMeter from "vue-simple-password-meter";
import { ExistUserMail , CreateSupplierV2 } from "@/api/index";
export default defineComponent({
    name: "SignUp",
    mounted() {
        document.title =
            window.VUE_APP_NAME + " - " + this.$t("Document.Title.SignUp");
    },
    components: { PasswordMeter },
    setup() {
        const password2 = ref("");
        const score = ref(null);
        const strength = ref(null);
        const onScore = (payload) => {
            score.value = payload.score;
            strength.value = payload.strength + " password";
        };
        return {
            password2,
            onScore,
            score,
            strength,
        };
    },
    data: () => ({
        loader: false,
        valid: true,
        ExistMail: null,
        step: 1,
        name: "",
        email: "",
        phoneNumber: null,
        password: null,
        passwordIsNotIdentique: null,
        showPass: false,
        showPass2: false,
        agreeTerm: false,
        msg: [],
        userInfo: {
           fullName: "",
           email: "",
           phoneNumber:"" ,
           password: "",
           confirmedPassword: "", 
           agreedToConditions: false
        },
    
    }),
    watch: {
        password(value) {
            this.password = value;
            if (this.password2 == "") {
                this.passwordIsNotIdentique = false;
            } else if (this.password == this.password2) {
                this.passwordIsNotIdentique = false;
            } else {
                this.msg["passwordIdentique"] = this.$t(
                    "signUp.passwordNoMatch"
                );
                this.passwordIsNotIdentique = true;
            }
            this.passwordIsNotIdentique
                ? (this.msg["passwordIdentique"] = this.$t(
                      "signUp.passwordNoMatch"
                  ))
                : (this.msg["passwordIdentique"] = this.strength);
                this.userInfo.password = this.password;
        },
        password2(value) {
            this.password2 = value;
            if (this.password2 == "") {
                this.passwordIsNotIdentique = false;
            } else if (this.password == this.password2) {
                this.passwordIsNotIdentique = false;
            } else {
                this.msg["passwordIdentique"] = this.$t(
                    "signUp.passwordNoMatch"
                );
                this.passwordIsNotIdentique = true;
            }
            this.passwordIsNotIdentique
                ? (this.msg["passwordIdentique"] = this.$t(
                      "signUp.passwordNoMatch"
                  ))
                : (this.msg["passwordIdentique"] = this.strength);
            this.userInfo.confirmedPassword = this.password2;
        },
        name(value) {
            this.name = value;
            this.userInfo.fullName = this.name;
        },
        email(value) {
            this.email = value;
            this.userInfo.email = this.email;
            this.ExistMail = null;
        },
        phoneNumber(value) {
            this.phoneNumber = value;
            this.userInfo.phoneNumber = `+${value}`;
        },
    },
    methods: {
        /* selectButton(type) {
            this.selectedButton = type;
            this.msg["selectProfile"] = '';
        }, */
        getCountryFromSelect(value) {
            this.country = value;
        },
        validateFormStep1() {
            this.loader = true;
            if (!this.name || this.name.length == 0) {
                this.msg["name"] = this.$t("warningInput.isrequired", {
                    itm: this.$t("signUp.fullName"),
                });
            } else {
                this.name = this.name.replace(/\s+/g, " ").trim();
                // eslint-disable-next-line
                if (!/^[a-z][a-z\s]*$/i.test(this.name)) {
                    this.msg["name"] = this.$t("warningInput.wrong", {
                        itm: this.$t("signUp.fullName"),
                    });
                } else if (!(this.name.split(/\W+/).length >= 2)) {
                    this.msg["name"] = this.$t("warningInput.wrong", {
                        itm: this.$t("signUp.fullName"),
                    });
                } else if (!(this.name.split(" ")[1].length >= 2)) {
                    this.msg["name"] = this.$t("warningInput.wrong", {
                        itm: this.$t("signUp.fullName"),
                    });
                } else {
                    this.msg["name"] = "";
                }
            }

            if (!this.email || this.email.length == 0) {
                this.msg["email"] = this.$t("warningInput.isrequired", {
                    itm: this.$t("signUp.email"),
                });
            }
            // eslint-disable-next-line
            else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
                this.msg['email'] = '';
            } else {
                this.msg["email"] = this.$t("warningInput.wrong", {
                    itm: this.$t("signUp.email"),
                });
            }

            if (!this.phoneNumber || this.phoneNumber.length == 0) {
                this.msg["phoneNumber"] = this.$t("warningInput.isrequired", {
                    itm: this.$t("signUp.phoneNumber"),
                });
            } else if (
                this.phoneNumber.length < 8 ||
                this.phoneNumber.length > 15
            ) {
                this.msg["phoneNumber"] = this.$t("warningInput.wrong", {
                    itm: this.$t("signUp.phoneNumber"),
                });
            } // eslint-disable-next-line
            else if (this.phoneNumber.match(/^[\+]?[0-9]{8,15}$/im)) {
                this.msg["phoneNumber"] = "";
            } else {
                this.msg["phoneNumber"] = this.$t("warningInput.wrong", {
                    itm: this.$t("signUp.phoneNumber"),
                });
            }

            if (
                !this.password ||
                this.password.length == 0 ||
                !this.password2 ||
                this.password2.length == 0
            ) {
                this.msg["passwordIdentique"] = this.$t(
                    "warningInput.isrequired",
                    { itm: this.$t("signUp.password") }
                );
                this.passwordIsNotIdentique = true;
            } else if (this.password == this.password2) {
                this.msg["passwordIdentique"] = "";
                this.passwordIsNotIdentique = false;
            } else {
                this.msg["passwordIdentique"] = this.$t(
                    "signUp.passwordNoMatch"
                );
                this.passwordIsNotIdentique = true;
            }

            if (this.msg["email"] == "") {
                ExistUserMail(this.email).then((res) => {
                    this.ExistMail = res.data;
                    if (this.ExistMail) {
                        this.msg["email"] = this.$t("warningInput.exist", {
                            itm: this.$t("signUp.email"),
                        });
                    }
                });
            } 
            if (
                        this.ExistMail == false &&
                        this.msg["email"] == "" &&
                        this.msg["name"] == "" &&
                        this.msg["phoneNumber"] == "" &&
                        !this.passwordIsNotIdentique){
                            this.validateFormStep2();
                        }else {
                            this.loader = false
                        }
            
        },
        validateFormStep2() {
            if (!this.agreeTerm) {
                this.msg["agreeTerm"] = this.$t("signUp.mustAgree");
            } else {
                this.msg["agreeTerm"] = "";
            }
            if (this.agreeTerm == true ) {
                this.userInfo.agreedToConditions = this.agreeTerm;
                    CreateSupplierV2(this.userInfo)
                        .then(() => {
                            this.$router.push({ name: 'VerifyEmail', params: { email: this.email } })
                        })
                        .catch(() => {
                        }).finally(()=> this.loader = false);
                    
                
            }else 
            {
                this.loader = false;
            }
        },
    },
    computed: {
        strengthTranslate() {
            switch (this.strength) {
                case "risky password":
                    return this.$t("signUp.passwordStrength.risky");
                case "guessable password":
                    return this.$t("signUp.passwordStrength.guessable");
                case "weak password":
                    return this.$t("signUp.passwordStrength.weak");
                case "safe password":
                    return this.$t("signUp.passwordStrength.safe");
                case "secure password":
                    return this.$t("signUp.passwordStrength.secure");
                default:
                    return this.$t("signUp.passwordStrength.risky");
            }
        },
        Color() {
            switch (this.score) {
                case 0:
                    return "#f95e68";
                case 1:
                    return "#fb964d";
                case 2:
                    return "#fdd244";
                case 3:
                    return "#b0dc53";
                case 4:
                    return "#35cc62";
                default:
                    return "#F3F3F3";
            }
        },
    },
});
</script>
<style scoped>
.title {
    font-family: "Manrope";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-transform: capitalize;
    color: #080c3e;
}

.stepText {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #ffffff;
}
.Large {
    font-weight: normal !important;
    font-family: "Inter", sans-serif !important;
    width: 100% !important;
    padding: 20px 40px !important;
    font-size: 24px !important;
    height: 100px !important;
}
.custom-placeholder input::placeholder {
  color: #555; /* Couleur plus sombre pour le placeholder */
  opacity: 1; /* Assurez-vous que l'opacité est à 1 pour une couleur solide */
}

</style>
